<template>
  <el-card :body-style="{ padding: '8px 0' }" class="mt-2 p-2">
    <div class="dayplanner-suggestion-item">
      <!-- QUICK SESSION -->

      <img v-if="type === 'INLINE_TASK'" class width="32" src="@/assets/flaticons/fire.svg">
      <div style="display: flex; flex-direction: column">
        <div>
          <h5>{{name}}</h5>
        </div>
        <div>
          <inline-editable-text
            @change="onChangeName"
            :value="checklistName"
            :floating-buttons="false"
            placeholder="Name your checklist"
            tooltip="Name your checklist"
            style="border: 1px" />
        </div>
      </div>

      <!-- {{type}} -->
      <!-- <pre>{{config}}</pre> -->

      <div style="display: flex; flex-direction: column; justify-content: flex-end">
        <div>
          <el-button
            size="mini"
            @click="onCreateCommitment"
            style="float: right; margin-right: 8px; width: 60px">
            add
          </el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import moment from '@/moment-gp'

export default {
  props: {
    name: {},
    type: {
      type: String,
      default: "all",
    },
    config: {
      type: Object,
    },
  },
  data: () => ({
    checklistName: "New Checklist"
  }),
  computed: {},
  methods: {
    onChangeName(name) {
      this.checklistName = name
    },
    async onCreateCommitment() {
      /*let data = {
        picture: "https://images.unsplash.com/photo-1517021897933-0e0319cfbc28?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1438&q=80",
        name: this.checklistName
      }
      this.$api.commitment_create({
        type: 'TASKLIST',
        goal_id: '-LfQfdAL-JMyMsJUvUkf',
        data: data
      }).then(() => {
        this.$models.commitmentMeta
        .with({ goalId: this.goalId })
        .update(this.commitmentId, { name: this.checklistName })
        this.$emit('saved', data);
        //this.$emit("add", this.itemId);
      });*/
      let goalId = '-LfQfdAL-JMyMsJUvUkf'
      let commitment = this.$api.commitment_model_new({ type: 'TASKLIST', goal_id: goalId, sortidx: 1 });
      commitment.picture = "https://images.unsplash.com/photo-1517021897933-0e0319cfbc28?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1438&q=80"
      commitment.committedTime = 15 * 60 // 15min for tutorial
      commitment.committedTimePerDay = 2 * 60 * 60; // Delete maximum time per day --> geht nicht
      // commitment.committedTimeDaily = 15 * 60
      commitment.meta.name = this.checklistName
      commitment.user.$id = commitment.$id
      let commitmentId = await commitment.write_with_meta();

      this.$emit("add", {
        subtype: 'ADHOC_SESSION',
        config: {
          goalId: goalId,
          commitmentId: commitmentId
        },
        name: this.checklistName,
        from: moment.currentTime().unix(),
        to: moment.currentTime().unix() + 60 * 60,
        sortidx: 10
      });

    }
  },
};
</script>
